export default __webpack_public_path__ + "static/media/3-shine.b402c947.png";